import { UserMenuLayout } from "@portal/components/layout/UserMenuLayout";
import { UserMenuOption } from "@portal/components/ui/UserMenuOption";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { HiOutlineUsers } from "react-icons/hi2";
import { NavLink } from "react-router-dom";

export const AgentUserMenu = () => {
	const { user } = useAuthenticatedUser();

	return (
		<UserMenuLayout
			user={user}
			logoutOptions={{
				openUrl: (url: string) => {
					window.open(url, "_self");
				},
			}}
		>
			{user.type === "agent" && user.role === "agent-admin" && (
				<NavLink to="/team">
					<UserMenuOption label="My Team" Icon={HiOutlineUsers} />
				</NavLink>
			)}
		</UserMenuLayout>
	);
};
